/**
 * Mapping between a Recipe and its FeedComponents.
 *
 * @note The interfaces in this file are more or less copied from the supabase generated types in the users-svc.
 */

import { number, object, string, type InferType } from "yup"

export const RecipeComponentSchemaMassKgMin = 0.001
export const RecipeComponentSchemaMixingTimeMinutesMax = 20

export const RecipeComponentSchema = object({
  feed_component_id: string().required(),
  mass_kg: number().required().min(RecipeComponentSchemaMassKgMin),
  mixing_time_s: number()
    .min(0)
    .max(RecipeComponentSchemaMixingTimeMinutesMax * 60)
    .nullable(),
  order: number().integer().min(0).required(),
  recipe_id: string().required(),
})

export const RecipeComponentCreateSchema = RecipeComponentSchema.omit([
  "recipe_id",
])

export type RecipeComponent = InferType<typeof RecipeComponentSchema>
export type RecipeComponentCreate = InferType<
  typeof RecipeComponentCreateSchema
>
